export const parents = (el: HTMLElement, selector: string): HTMLElement[] => {
  const result = [];
  while ((el = el.parentNode as HTMLElement) && el !== (window.document as Node)) {
    if (!selector || el.matches(selector)) {
      result.unshift(el);
    }
  }

  return result;
};
